import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";

import { Link } from "react-router-dom";
import { Fieldset, Title, Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isBefore, isAfter } from "date-fns";
import { toast } from "react-toastify";

import { EditFormButtonGroup } from "../inputs";
import {
  UPDATE_EMPLOYEE_CERTIFICATION_MUTATION,
  DELETE_EMPLOYEE_CERTIFICATION_MUTATION
} from "../../graphql/EmployeeCertifications/EmployeeCertifications.graphql";
import { getUTCFormattedDate } from "../../utils";
import EmployeeCertificationForm from "./EmployeeCertificationForm";

class EditEmployeeCertificationForm extends Component {
  state = {
    CertificationTypeRecIdRef: "",
    ExpirationDate: "",
    LastTestDate: "",
    Note1: "",
    CertificationName: "",
    ...this.props.certification
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const {
      CertificationTypeRecIdRef,
      ExpirationDate,
      LastTestDate,
      Note1,
      CertificationName
    } = this.state;
    const { onComplete } = this.props;
    return (
      <Mutation
        mutation={UPDATE_EMPLOYEE_CERTIFICATION_MUTATION}
        refetchQueries={["ALL_EMPLOYEE_CERTIFICATIONS_QUERY"]}
      >
        {(updateCertification, { loading, error }) => (
          <React.Fragment>
            <header className="page-head">
              <div className="page-head-start">
                <Title>Edit Certification</Title>
              </div>
              <div className="page-head-end">
                <Button
                  outlined
                  as={Link}
                  color="link"
                  size="small"
                  tabIndex="-1"
                  to={`/hr/employees/${this.props.certification.EmployeeRecIdRef}/personal`}
                  onClick={onComplete}
                >
                  <Icon>
                    <FontAwesomeIcon icon="user" />
                  </Icon>
                  <span>{this.props.certification.EmployeeName}</span>
                </Button>
              </div>
            </header>
            <form
              id="edit-employee-certification"
              method="POST"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  if (!LastTestDate) {
                    throw new Error("Last Test Date cannot be blank.");
                  }
                  if (!ExpirationDate) {
                    throw new Error("Expiration Date cannot be blank.");
                  }
                  if (isBefore(new Date(LastTestDate), new Date("1753"))) {
                    throw new Error("Last Test Date must be after 1753 AD.");
                  }
                  if (isAfter(new Date(LastTestDate), new Date("9999"))) {
                    throw new Error("Last Test Date must be before 9999 AD.");
                  }
                  if (isBefore(new Date(ExpirationDate), new Date("1753"))) {
                    throw new Error("Expiration Date must be after 1753 AD.");
                  }
                  if (isAfter(new Date(ExpirationDate), new Date("9999"))) {
                    throw new Error("Expiration Date must be before 9999 AD.");
                  }
                  await updateCertification({
                    variables: {
                      data: {
                        CertificationTypeRecIdRef: parseInt(
                          CertificationTypeRecIdRef
                        ),
                        ExpirationDate: ExpirationDate
                          ? getUTCFormattedDate(ExpirationDate)
                          : null,
                        LastTestDate: LastTestDate
                          ? getUTCFormattedDate(LastTestDate)
                          : null,
                        Note1,
                        CertificationName
                      },
                      where: {
                        RecId: this.props.certification.RecId
                      }
                    }
                  });
                  onComplete();
                } catch (err) {
                  toast.error(err.message);
                }
              }}
            >
              <Fieldset disabled={loading}>
                <EmployeeCertificationForm
                  inputs={{
                    CertificationName,
                    CertificationTypeRecIdRef,
                    ExpirationDate,
                    LastTestDate,
                    Note1
                  }}
                  onChange={this.onChange}
                />
                <EditFormButtonGroup
                  deleteMutation={DELETE_EMPLOYEE_CERTIFICATION_MUTATION}
                  form="edit-employee-certification"
                  refetchQueries={["ALL_EMPLOYEE_CERTIFICATIONS_QUERY"]}
                  variables={{
                    where: { RecId: this.props.certification.RecId }
                  }}
                  onComplete={onComplete}
                />
              </Fieldset>
            </form>
          </React.Fragment>
        )}
      </Mutation>
    );
  }
}

EditEmployeeCertificationForm.propTypes = {
  certification: PropTypes.object,
  onComplete: PropTypes.func
};
export default EditEmployeeCertificationForm;
